import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import {interceptProps} from '@/styled-components/utils';

interface IProps {
  containerClassName?: string;
  debug?: boolean;
  anchor?: {
    x?: number;
    y?: number;
    position?: 'top' | 'bottom' | 'right';
    alignLeft?: boolean; // 좌측 정렬 여부 (false인 경우 x축 중앙을 기준으로 함)
  };
}

export const MarkerContentContainer = ({
  containerClassName,
  anchor = {x: 0, y: 0, position: 'top'},
  debug,
  ...props
}: IProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <Point className={containerClassName} debug={debug}>
      <Root anchor={anchor} {...props} />
    </Point>
  );
};

const Point = styled('div').withConfig({
  shouldForwardProp: interceptProps(['debug']),
})<IProps>`
  position: relative;
  top: 0;
  left: 0;
  ${({debug}) =>
    debug &&
    `
    &::before {
      content: '';
      left: 0;
      top: 0;
      width: 2px;
      height: 2px;
      background: red;
      z-index: 999999;
      display: block;
      position: absolute;
    }
  `}
`;

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['anchor']),
})<IProps>`
  position: absolute;
  top: 0;
  left: 0;
  ${({anchor}) => `
    transform: translate(calc(${anchor?.alignLeft ? '0px' : '-50%'} + ${
    anchor?.x ?? 0
  }px), calc(${
    anchor?.position === 'bottom'
      ? '0px'
      : anchor?.position === 'right'
      ? '-50%'
      : '-100%'
  } + ${anchor?.y ?? 0}px));
  `}
`;
